import Routes from "./routes"
import AuthenticationProvider from "./authentication/authentication.provider"
import { QueryClientProvider } from "@tanstack/react-query"
import { queryClient } from "./api/query-client"

export default function App() {
  return (
    <AuthenticationProvider>
      <QueryClientProvider client={queryClient}>
        <Routes />
      </QueryClientProvider>
    </AuthenticationProvider>
  )
}
